"use client";

import Image from "next/image";
import Link from "next/link"; // Import Link
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

export const Logo = () => {
  const { theme } = useTheme();
  const [mounted, setMounted] = useState(false);
  const [logo, setLogo] = useState<string>("kautious.png"); // Default logo

  useEffect(() => {
    setMounted(true);
    if (theme === "light") {
      setLogo("kautious.png");
    } else {
      setLogo("kautious-white.png");
    }
  }, [theme]);

  // Only render the Image component after the component has mounted
  if (!mounted) {
    return null;
  }

  // Wrap Image with Link
  return (
    <Link href="/" aria-label="Go to homepage">
      <Image
        src={"/images/" + logo}
        alt={"Kautious Co."}
        width={200}
        height={53}
      />
    </Link>
  );
};
